<template>
  <div
    v-loading="loading"
    :style="{'height':getHeight>getWidth?getHeight+'px':'100%','width':getWidth+'px'}"
    element-loading-background="rgba(255,255,255,1)"
  >
    <div
      v-cloak
      v-if="!loading&&finish"
      class="main"
      style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;"
    >
      <h1 style="font-size:25px;padding:10px;text-align: center;">
        {{ videoText }}，点击
        <span style="color: #337eff" @click="windowClose">关闭</span>
        页面...
      </h1>
    </div>
    <div
      v-else-if="!loading && !finish"
      v-cloak
      ref="main"
      class="main"
      :style="{'height':getHeight>getWidth?getHeight+'px':'100%','width':getWidth+'px'}"
    >
      <div class="wrapper">
        <div class="content">
          <!--画面div-->
          <div ref="large" class="main-window">
            <p class="bot-line">{{ newName+name }}</p>
          </div>
          <div class="sub-window-wrapper">
            <!--小画面div-->
            <template v-if="remoteStreams.length">
              <div
                v-for="item in remoteStreams"
                :key="item.getId()"
                ref="small"
                class="sub-window sub-video"
                :data-uid="item.getId()"
              >
                <p class="bot-line">
                  <i v-if="!item.audio" class="media-audio"></i>
                  <i v-if="!item.video" class="media-video"></i>
                  <i v-if="item.audioLevelHelper" class="speak-video"></i>
                  <template v-for="items in remoteUsers">
                    <span v-if="items.uid===item.streamID" :key="items.uid">{{ items.nickName }}</span>
                  </template>
                </p>
              </div>
            </template>
            <div v-else ref="small" class="sub-window">
              <span class="loading-text">等待对方加入…</span>
            </div>
          </div>
        </div>
        <!--底层栏-->
        <ul class="tab-bar">
          <li class="over" @click="windowClose">退出调解室</li>
          <li v-if="personIdentity === '调解员'" class="over" @click="handleClose">结束调解</li>
          <li v-if="personIdentity === '调解员'" class="over" @click="handleRecord">
            <span>{{ recordTime }}</span>
            <span>{{ recordText }}</span>
          </li>
          <li :class="{silence:true, isSilence}" @click="setOrRelieveSilence"></li>
          <li :class="{stop:true,isStop}" @click="stopOrOpenVideo"></li>
        </ul>
        <div class="mobile-btn">
          <div class="div-btn div-p">
            <p>{{ caseNo }}</p>
            <p>调解状态：第{{ times }}次开庭</p>
          </div>
          <!--          <div class="div-btn"  @click="handleMaterials">-->
          <!--            <img src="../../assets/img/cailiao.png" alt="">-->
          <!--            <p>案件材料</p>-->
          <!--          </div>-->
          <div class="div-btn" @click="handleWorkMobile">
            <img src="../../assets/img/work.png" alt="">
            <p>工作台</p>
          </div>
        </div>
      </div>
      <div v-if="personIdentity === '调解员'" class="file">
        <div class="file-box">
          <div class="file-title">
            <el-tooltip class="item" effect="dark" :content="caseNo" placement="bottom">
              <h4>{{ caseNo }}</h4>
            </el-tooltip>
            <div class="mediate-status">
              <p>调解状态：第{{ times }}次开庭</p>
              <!--<p>调解时长：00:00:12</p>-->
            </div>
            <div>
              <el-tooltip class="item" effect="dark" :content="isFullscreen?'退出全屏':'全屏展示'" placement="bottom">
                <el-button icon="el-icon-full-screen" size="medium" circle @click="clickFun"></el-button>
              </el-tooltip>
              <!--            <el-tooltip class="item" effect="dark" content="保存" placement="bottom">-->
              <!--              <el-button type="primary" size="small" @click="saveDocument">保存</el-button>-->
              <!--            </el-tooltip>-->
            </div>
          </div>
          <div class="file-show">
            <el-tabs v-model="activeName">
              <el-tab-pane label="案件材料" name="first">
                <el-collapse v-model="activeNames" accordion>
                  <el-collapse-item
                    v-for="(item,index) in details"
                    :key="index"
                    :title="item.fileTypeOfDesc+'（'+item.fileCount+'）'"
                    :name="index*1+1"
                  >
                    <el-tooltip
                      v-for="(sItem,sIndex) in item.filePaths"
                      :key="sIndex"
                      class="item"
                      effect="dark"
                      :content="sItem.fileName"
                      placement="top"
                    >
                      <div
                        class="file-item"
                        style="margin: 10px;"
                        @click="handleRiviewFile(sItem,item.fileTypeOfDesc,false)"
                      >
                        <img :src="previewFileType(sItem.filePath)" alt="">
                        <p>{{ sItem.fileName }}</p>
                      </div>
                    </el-tooltip>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="工作台" name="second">
                <el-collapse v-model="activeNames" accordion>
                  <template v-for="(item,index) in details">
                    <el-collapse-item
                      v-if="[6,7,8,9,15,16,17,18,21].includes(item.fileType)"
                      :key="index"
                      :title="item.fileTypeOfDesc+'（'+item.fileCount+'）'"
                      :name="index*1+1"
                    >
                      <el-tooltip
                        v-for="(sItem,sIndex) in item.filePaths"
                        :key="sIndex"
                        class="item"
                        effect="dark"
                        :content="sItem.fileName"
                        placement="top"
                      >
                        <div
                          class="file-item"
                          style="margin: 10px;"
                        >
                          <div class="del-modal">
                            <div
                              class="view-sty"
                              style="padding-right:5px"
                              @click="handleRiviewFile(sItem,sItem.fileName,true,(item.fileType===7||item.fileType===6)?true:false)"
                            >
                              预览
                            </div>
                            <div class="del-sty" @click.stop="handleDelFile(sItem)">删除</div>
                          </div>
                          <img :src="previewFileType(sItem.filePath)" alt="">
                          <p :style="{color:sItem.signStatus?'red':''}">{{ sItem.fileName }}</p>
                        </div>
                      </el-tooltip>
                    </el-collapse-item>
                  </template>
                </el-collapse>
                <div
                  style="width: 100%;display: flex;align-items:center;justify-content:space-between;padding: 10px 0;"
                >
                  <el-button style="width: 100%;" type="primary" @click="downloadFile=true,caseFileType=undefined">
                    下载工作台文件模板
                  </el-button>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="bot-btn">
              <el-button type="primary" style="width:100%;" @click="visibleFile=true,caseFileType=undefined">
                上传案件材料 / 工作台文件
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="file">
        <div class="file-box">
          <div class="file-title">
            <el-tooltip class="item" effect="dark" :content="caseNo" placement="bottom">
              <h4>{{ caseNo }}</h4>
            </el-tooltip>
            <div class="mediate-status">
              <p>调解状态：第{{ times }}次开庭</p>
            </div>
            <div>
              <el-tooltip class="item" effect="dark" :content="isFullscreen?'退出全屏':'全屏展示'" placement="bottom">
                <el-button icon="el-icon-full-screen" size="medium" circle @click="clickFun"></el-button>
              </el-tooltip>
            </div>
          </div>
          <div class="file-show">
            <div class="bot-btn">
              <el-button type="primary" style="width:100%;" @click="handleWorkMobile">
                工作台
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <el-drawer
        :visible.sync="materialsDrawer"
        :with-header="false"
        :show-close="false"
        size="100%"
      >
        <div class="drawer-main">
          <div class="sub-file-show">
            <el-collapse v-model="activeNames" accordion>
              <el-collapse-item
                v-for="(item,index) in details"
                :key="index"
                :title="item.fileTypeOfDesc+'（'+item.fileCount+'）'"
                :name="index*1+1"
              >
                <el-tooltip
                  v-for="(sItem,sIndex) in item.filePaths"
                  :key="sIndex"
                  class="item"
                  effect="dark"
                  :hide-after="500"
                  :content="sItem.fileName"
                  placement="top"
                >
                  <div class="file-item" @click="mobilePreview(true,false,sItem)">
                    <img :src="previewFileType(sItem.filePath)" alt="">
                    <p :style="{color:sItem.signStatus?'red':''}">{{sItem.fileName }}</p>
                  </div>
                </el-tooltip>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="file-btn">
            <div style="width: 40%">
              <el-button type="primary" round plain style="width: 100%;" @click="materialsDrawer=false">返 回</el-button>
            </div>
            <div style="width: 40%">
              <el-button type="primary" round icon="el-icon-edit" style="width: 100%;" @click="visibleFile=true">
                添加材料
              </el-button>
            </div>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :visible.sync="assistDrawer"
        :with-header="false"
        :show-close="false"
        size="100%"
      >
        <div class="drawer-main">
          <div class="sub-file-show">
            <el-collapse v-model="activeNames" accordion>
              <template v-for="(item,index) in details">
                <el-collapse-item
                  v-if="[6,7,8,9,15,16,17,18].includes(item.fileType)"
                  :key="index"
                  :title="item.fileTypeOfDesc+'（'+item.fileCount+'）'"
                  :name="index*1+1"
                >
                  <el-tooltip
                    v-for="(sItem,sIndex) in item.filePaths"
                    :key="sIndex"
                    class="item"
                    effect="dark"
                    :hide-after="500"
                    :content="sItem.fileName"
                    placement="top"
                  >
                    <div class="file-item" @click="mobilePreview(true,true,sItem)">
                      <img :src="previewFileType(sItem.filePath)" alt="">
                      <p :style="{color:sItem.signStatus?'red':''}">{{sItem.fileName }}</p>
                    </div>
                  </el-tooltip>
                </el-collapse-item>
              </template>
            </el-collapse>
          </div>
          <div class="file-btn">
            <div style="width: 80%">
              <el-button type="primary" round plain style="width: 100%;" @click="assistDrawer=false">返 回</el-button>
            </div>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :visible.sync="previewDrawer"
        :with-header="false"
        :show-close="false"
        size="100%"
      >
        <div class="drawer-main">
          <div class="sub-file-show" :style="{height:visibleVideoM&&'100%'}">
            <div v-if="visibleImgM" class="mobile-img">
              <img
                :oncontextmenu="false"
                :onselectstart="false"
                :draggable="false"
                :src="imgStrM"
                alt=""
              >
            </div>
            <div v-else-if="visiblePdfM" style="width: 100%;height: 100%;">
              <div id="pdf"></div>
            </div>
            <div v-else-if="visibleWordM">
              <div ref="refWordM"/>
            </div>
            <div v-else-if="visibleVideoM">
              <video
                :src="videoStrM"
                preload="auto"
                controls
                autoplay
                style="width: 100%;height:100%;border-radius: 5px;"
              ></video>
            </div>
            <div v-else>
              <p style="line-height: 100%;text-align: center">暂无文档</p>
            </div>
          </div>
          <div class="file-btn">
            <div :style="{width: isPreviewBtn?'40%':'80%'}">
              <el-button type="primary" round plain style="width: 100%;" @click="mobilePreviewBack">返 回</el-button>
            </div>
            <div v-if="isPreviewBtn && !isSignature" style="width: 40%">
              <el-button type="primary" round icon="el-icon-edit" style="width: 100%;" @click="handWriting">
                签署调解协议
              </el-button>
            </div>
          </div>
        </div>
      </el-drawer>
      <!--      图片预览-->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="visibleImg"
        width="700px"
        :destroy-on-close="false"
        top="5vh"
        @close="handleCloseDialog"
      >
        <div class="dialog-box dialog-img">
          <img
            :oncontextmenu="false"
            :onselectstart="false"
            :draggable="false"
            :src="imgStr"
            style="max-width:700px;max-height:100%;"
            alt=""
          >
        </div>
      </el-dialog>
      <!--    pdf预览-->
      <el-dialog
        :visible.sync="visiblePdf"
        width="700px"
        :destroy-on-close="false"
        top="5vh"
        @close="handleCloseDialog"
      >
        <div slot="title">
          {{ dialogTitle }}
          <el-button
            v-if="isWork && existHandSign"
            style="margin-left: 15px;"
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="signImage"
          >
            调解员签字
          </el-button>
        </div>
        <div class="dialog-pdf" v-loading="iframeLoading">
          <iframe :src="pdfStr" width="680" height="550" frameborder="0"></iframe>
        </div>
      </el-dialog>
      <!--      视频预览-->
      <el-dialog
        title="录制视频"
        :visible.sync="visibleVideo"
        width="700px"
        :destroy-on-close="false"
        top="5vh"
        @close="handleCloseDialog"
      >
        <video :src="videoStr" controls style="width: 100%;border-radius: 5px;"></video>
      </el-dialog>
      <!--    word预览-->
      <el-dialog
        :visible.sync="visibleWord"
        width="700px"
        :destroy-on-close="false"
        top="5vh"
        @close="handleCloseDialog"
      >
        <div slot="title">
          {{ dialogTitle }}
          <!--          <el-button v-if="isWork" style="margin-left: 15px;" type="primary" size="mini" icon="el-icon-edit">-->
          <!--            调解员签字-->
          <!--          </el-button>-->
        </div>
        <div ref="refWord"/>
      </el-dialog>
      <!--    上传文件-->
      <el-dialog
        title="上传材料"
        :visible.sync="visibleFile"
        width="340px"
      >
        <div style="padding: 0 10px;">
          <el-select v-model="caseFileType" placeholder="请选择文件类型">
            <el-option
              v-for="item in details"
              :key="item.fileType"
              :label="item.fileTypeOfDesc"
              :value="item.fileType"
            >
            </el-option>
          </el-select>
          <div style="margin-top: 20px;display: flex;">
            <el-upload
              class="upload-demo"
              :action="action"
              multiple
              :on-success="onUploadFileSuccess"
              :before-upload="beforeUploadOnChange"
              :show-file-list="false"
              style="width: 100%;"
              :data="{
                caseId:caseId,
                fileType:caseFileType,
                uploadRole:newName,
                source:0,
                meetingOrderId:meetingRecordId
              }"
            >
              <el-button size="small" type="primary" :loading="uploadLoading">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传png/jpg/docx/pdf文件，且不超过10M</div>
            </el-upload>
          </div>
        </div>
      </el-dialog>
      <!--    下载模板-->
      <el-dialog
        title="下载模板"
        :visible.sync="downloadFile"
        width="340px"
      >
        <div style="padding: 0 10px;">
          <el-select v-model="caseFileType" placeholder="请选择文件类型">
            <template v-for="item in details">
              <el-option
                v-if="[6,7,8,9,15,16,17,18].includes(item.fileType)"
                :key="item.fileType"
                :label="item.fileTypeOfDesc"
                :value="item.fileType"
              >
              </el-option>
            </template>
          </el-select>
          <el-button size="small" type="primary" style="margin-top: 20px" @click="handleDownTemplate(caseFileType)">
            下载模板
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { message } from '../../components/message'
import { renderAsync } from 'docx-preview'
import { getToken } from '../../common'
import NERTC from 'nertc-web-sdk'
import screenfull from 'screenfull'
import Pdfh5 from 'pdfh5'
import config from '../../../config'
import 'pdfh5/css/pdfh5.css'
import { Dialog } from 'vant'
import 'vant/lib/dialog/style'

const Base62 = require('../../tool/base62.js').Base62
const dict = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
const b62 = Base62.createEncoder(dict)

function getRequest(parName) {
  const str = parName + '='
  let gvalue = ''
  const HREF = location.href
  if (HREF.indexOf(str) > 0) {
    gvalue = HREF.substring(HREF.indexOf(str) + str.length, HREF.length)
    if (gvalue.indexOf('&') > 0) gvalue = gvalue.substring(0, gvalue.indexOf('&'))
    if (gvalue.indexOf('#') > 0) gvalue = gvalue.split('#')[0]
    gvalue = decodeURIComponent(gvalue)
  }
  return gvalue
}

const h = document.body.clientHeight
const w = document.body.clientWidth
export default {
  name: 'multiple',
  data() {
    return {
      downloadFile: false,
      // 变色
      isSignature: false,
      uploadLoading: false,
      recordTime: '00:00:00',
      recordText: '开始录制',
      stopRecord: true,
      hours: 0,
      minutes: 0,
      seconds: 0,
      loading: false,
      videoText: '调解已经结束',
      value: '',
      action: '/acknowledgment/case/file/upload',
      caseFileType: undefined,
      visibleFile: false,
      fileList: [],
      activeName: 'first',
      activeNames: ['1'],
      isSilence: false,
      isStop: false,
      client: null,
      // pId: Math.ceil(Math.random() * 1e5),
      localStream: null,
      remoteStreams: [],
      max: 20,
      isFullscreen: false,
      assistDrawer: false, // 抽屉开关
      materialsDrawer: false,
      previewDrawer: false,
      isPreviewBtn: true,
      html: null,
      // 案号
      caseNo: '调解演示',
      // 案件编号
      caseId: null,
      // 姓名
      name: null,
      // 角色
      personIdentity: null,
      // 次数
      times: null,
      details: {},
      visibleWord: false,
      visibleImg: false,
      visiblePdf: false,
      visibleVideo: false,
      videoStr: null,
      imgStr: null,
      pdfStr: null,
      visibleWordM: false,
      visibleImgM: false,
      visiblePdfM: false,
      visibleVideoM: false,
      videoStrM: null,
      imgStrM: null,
      pdfStrM: null,
      dialogTitle: null,
      pdfh5: null,
      remoteUsers: [],
      pId: null,
      meetingRecordId: null,
      participantId: null,
      neteaseRoomId: null,
      finish: true,
      taskId: null,
      isWork: false,
      existHandSign: false,
      posY: null,
      signFileId: null,
      userId: null,
      iframeLoading: false
    }
  },
  computed: {
    getHeight: function () {
      // 获取可用高度
      // return h > w ? w : (h - 1)
      return h - 1
    },
    getWidth: function () {
      // 获取可用宽度
      // return h > w ? h : w
      return w
    }
  },
  created() {
    // 从链接截取参数
    this.personIdentity = getRequest('personIdentity')
    if (this.personIdentity === '调解员') {
      this.caseNo = getRequest('caseNo')
      this.existHandSign = Number.parseInt(getRequest('existHandSign'))
      console.log(this.existHandSign)
      this.name = getRequest('name')
      this.userId = getRequest('userId')
      this.newName = this.personIdentity
    } else {
      this.caseNo = b62.decode(getRequest('caseNo'))
      this.name = b62.decode(getRequest('name'))
      this.personIdentity = b62.decode(getRequest('personIdentity'))
      const textDecoder = new TextDecoder()
      try {
        this.caseNo = textDecoder.decode(this.caseNo)
        this.name = textDecoder.decode(this.name)
        this.personIdentity = textDecoder.decode(this.personIdentity)
        this.newName = this.personIdentity.split('签字').join('')
      } catch (e) {
        this.caseNo = JSON.stringify(Array.from(this.caseNo))
        this.name = JSON.stringify(Array.from(this.name))
        this.personIdentity = JSON.stringify(Array.from(this.personIdentity))
        this.newName = this.personIdentity.split('签字').join('')
      }
    }
    console.log(this.newName)
    console.log(this.personIdentity)
    console.log(this.name)
    this.caseId = getRequest('channelName') || null
    this.participantId = getRequest('participantId') || null
    this.meetingRecordId = getRequest('meetingRecordId') || null
    this.neteaseRoomId = getRequest('neteaseRoomId') || null
    this.posY = getRequest('posY') || null
    console.log(this.posY)
    // this.pId = getRequest('pId')
    // 加入会议
    this.joinMeeting()
  },
  mounted() {
    // 全屏
    // requestFullscreen()
    window.self = this
  },
  async destroyed() {
    try {
      await this.client.leave()
      this.localStream.destroy()
      this.client.destroy()
    } catch (e) {
      // 为了兼容低版本，用try catch包裹一下
      console.log(e)
    }
  },
  beforeDestroy() {
    // 全屏插件销毁
    this.destroy()
  },
  methods: {
    handleMaterials() {
      this.materialsDrawer = true
      this.getCaseDetails()
    },
    signImage() {
      this.iframeLoading = true
      this.$Http.signImage({
        fileId: this.signFileId,
        userId: this.userId
      }).then(res => {
        if (res.success) {
          this.pdfStr = res.data
          // 获取文件
          this.getCaseDetails()
          this.iframeLoading = false
        }
      })
    },
    windowClose() {
      window.open('about:blank', '_self').close()
    },
    handleDownTemplate(fileType) {
      this.$Http.handleDownTemplate({
        fileType: fileType
      }).then(res => {
        if (res.success) {
          window.open(res.data, '_blank')
        } else {
          this.$message.error('暂无可用模板！')
        }
      })
    },
    // 加入会议
    joinMeeting() {
      this.loading = true
      this.$Http.joinMeeting({
        meetingId: this.neteaseRoomId,
        userId: this.userId
      }).then(res => {
        if (res.success) {
          this.finish = false
          setTimeout(() => {
            this.loading = false
            // 初始化音视频实例
            this.createInit()
            // 新增会议昵称信息
            this.getNickInfo()
            // 获取文件
            this.getCaseDetails()
          }, 2000)
        } else {
          this.finish = true
          setTimeout(() => {
            this.loading = false
          }, 2000)
          this.videoText = res.message
        }
      })
    },
    // 结束会议
    handleClose() {
      this.$Http.delMeeting({
        meetingId: this.neteaseRoomId
      }).then(res => {
        if (res.success) {
          this.finish = true
          this.videoText = '调解已经结束'
        }
      })
    },
    // 点击录制
    handleRecord() {
      if (this.stopRecord) {
        this.$Http.startRecord({
          neteaseMeetingId: this.neteaseRoomId
        }).then(res => {
          if (res.success) {
            this.recordText = '停止录制'
            this.stopRecord = false
            this.taskId = res.data
            this.timer()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        // if (this.minutes > 5) {
        this.$Http.stopRecord({
          neteaseMeetingId: this.neteaseRoomId,
          taskId: this.taskId
        }).then(res => {
          if (res.success) {
            this.recordText = '开始录制'
            this.stopRecord = true
            this.timer()
            this.recordTime = '00:00:00'
            this.hours = 0
            this.minutes = 0
            this.seconds = 0
          }
        })
        // } else {
        //   this.$message.error('至少录制5分钟才能停止录制！')
        // }
      }
    },
    timer() {
      const t = setTimeout(() => {
        this.seconds++
        if (this.seconds > 59) {
          this.minutes++
          this.seconds = 0
        }
        if (this.minutes > 59) {
          this.hours++
          this.minutes = 0
        }
        clearTimeout(t)
        !this.stopRecord && this.timer()
      }, 1000)
      const h = this.hours < 10 ? '0' + this.hours : this.hours
      const m = this.minutes < 10 ? '0' + this.minutes : this.minutes
      const s = this.seconds < 10 ? '0' + this.seconds : this.seconds
      this.recordTime = h.concat(':', m, ':', s)
    },
    // 新增会议昵称信息
    getNickInfo() {
      this.$Http.nickInfo({
        nickname: this.personIdentity + this.name,
        caseId: this.caseId,
        meetingRecordId: this.meetingRecordId,
        participantId: this.participantId
      }).then(res => {
        this.pId = res.data.pid
        this.times = res.data.times || this.times
        this.getToken().then(token => {
          this.joinChannel(token)
        }).catch(e => {
          message(e)
        })
      })
    },
    // 删除调解协议
    handleDelFile(sItem) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$Http.delFile({
          caseId: this.caseId,
          fileId: sItem.fileId
        }).then(res => {
          if (res.success) {
            this.$message.success('删除成功！')
            this.getCaseDetails()
          }
        })
      })
    },
    // 点击工作台再获取文件列表
    handleWorkMobile() {
      this.assistDrawer = true
      this.getCaseDetails()
    },
    // 点击签署调解协议
    handWriting() {
      this.$Http.handWriting({
        name: this.name,
        personIdentity: this.personIdentity,
        fileId: this.fileId,
        posY: this.posY,
        participantId: this.participantId
      }).then(res => {
        if (res.success) {
          this.previewDrawer = false
          this.assistDrawer = false
          // 跳转新窗口
          window.open(res.data, '_self')
          // 本窗口打开
          // window.open(res.data)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //  上传文件之前
    beforeUploadOnChange(file) {
      this.uploadLoading = true
      return new Promise((resolve, reject) => {
        const isJPEG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        // const isDOC = file.type === 'application/msword';
        const isDOCX = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        const isPDF = file.type === 'application/pdf'
        const isPG = (isJPEG || isPNG || isPDF || isDOCX)
        const isLt5M = file.size / 1024 / 1024 < 10
        if (this.caseFileType === undefined || this.caseFileType < 0 || this.caseFileType === null || this.caseFileType === '') {
          this.$message.error('请先选择文件类型!', 2)
          return false
        } else if ([6, 7, 8, 9, 15, 16, 17, 18].includes(this.caseFileType) && !isPDF && !isDOCX) {
          this.$message.error('工作台文件只能上传pdf和word类型文件!', 2)
          return false
        } else if ([6, 7, 8, 9, 15, 16, 17, 18].includes(this.caseFileType) && this.personIdentity !== '调解员') {
          this.$message.error('工作台文件只能由调解员上传!', 2)
          return false
        } else if (!isPG) {
          this.$message.error('上传文件格式错误，请重新上传!', 2)
          return false
        } else if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 10MB!', 2)
          return false
        } else {
          this.uploadLoading = false
          return resolve(true)
        }
      })
    },
    // 手机端预览返回
    mobilePreviewBack() {
      this.previewDrawer = false
      this.imgStrM = ''
      this.pdfStrM = ''
    },
    // 手机端预览窗口 111
    mobilePreview(bol1, bol2, sItem) {
      this.previewDrawer = bol1
      this.isPreviewBtn = bol2
      this.isSignature = sItem.signStatus
      if (bol2) {
        this.$Http.getCaseDetails({
          duoyuanCaseId: this.caseId
        }).then(res => {
          if (res.success) {
            res.data.forEach(item => [6, 7, 8, 9, 15, 16, 17, 18].includes(item.fileType) &&
              item.filePaths.forEach(fps => fps.fileId === sItem.fileId && this.mobileView(fps.filePath)))
          }
        })
      } else {
        this.mobileView(sItem.filePath)
      }
      this.fileId = sItem.fileId
    },
    mobileView(str) {
      const previewType = str ? str.substring(str.lastIndexOf('.') + 1) : ''
      if (previewType === 'png' || previewType === 'jpeg' || previewType === 'jpg') {
        this.visibleWordM = false
        this.visiblePdfM = false
        this.visibleVideoM = false
        this.visibleImgM = true
        this.imgStrM = str
      } else if (previewType === 'pdf') {
        this.visibleWordM = false
        this.visibleImgM = false
        this.visibleVideoM = false
        this.visiblePdfM = true
        this.pdfStrM = str
        setTimeout(() => {
          this.pdfh5 = new Pdfh5('#pdf', { pdfurl: str, goto: 1 })
          this.pdfh5.on('ready', function () {
            console.log('总页数:' + this.totalNum)
          })
          // 监听pdf加载完成事件，加载失败、渲染成功都会触发
          this.pdfh5.on('complete', (status, msg, time) => {
            console.log('状态:' + status + '，信息:' + msg + '，耗时:' + time + '毫秒')
          })
        }, 500)
      } else if (previewType === 'docx') {
        this.visibleImgM = false
        this.visiblePdfM = false
        this.visibleVideoM = false
        this.visibleWordM = true
        const xhr = new XMLHttpRequest()
        xhr.open('get', str, true)
        xhr.responseType = 'arraybuffer'
        xhr.onload = () => {
          if (xhr.status === 200) {
            const options = {
              className: 'docx', // 默认和文档样式类的类名/前缀
              inWrapper: true, //  启用围绕文档内容渲染包装器
              ignoreWidth: false, //  禁止页面渲染宽度
              ignoreHeight: false, //  禁止页面渲染高度
              ignoreFonts: false, //  禁止字体渲染
              breakPages: true, //  在分页符上启用分页
              ignoreLastRenderedPageBreak: true, //  禁用lastRenderedPageBreak元素的分页
              experimental: false, //  启用实验性功能（制表符停止计算）
              trimXmlDeclaration: true, //   如果为真，xml声明将在解析之前从xml文档中删除
              debug: false, //  启用额外的日志记录
              useBase64URL: true, // 如果为true，图片、字体等将被转换为base 64 URL，否则使用URL.createObjectURL
              useMathMLPolyfill: false, //  包括用于 chrome、edge 等的 MathML polyfill。
              showChanges: false // 启用文档更改（插入/删除）的实验性呈现
            }
            xhr.response.byteLength ? renderAsync(xhr.response, this.$refs.refWordM, null, options) : this.$message.error('空白文件')
          }
        }
        xhr.send()
      } else if (previewType === 'mp4') {
        this.visibleImgM = false
        this.visiblePdfM = false
        this.visibleWordM = false
        this.visibleVideoM = true
        this.videoStrM = str
      } else {
        this.visibleImgM = false
        this.visiblePdfM = false
        this.visibleWordM = false
        this.visibleVideoM = false
        this.$message.error('文件类型错误,只能是pdf/docx/png/jpg类型的文件')
      }
    },
    // 预览文件
    previewFileType(str) {
      const previewType = str ? str.substring(str.lastIndexOf('.') + 1) : ''
      if (previewType === 'png') {
        return require('../../assets/img/png-ext.png')
      } else if (previewType === 'pdf') {
        return require('../../assets/img/pdf-ext.png')
      } else if (previewType === 'doc' || previewType === 'docx') {
        return require('../../assets/img/word-ext.png')
      } else if (previewType === 'jpg' || previewType === 'jpeg') {
        return require('../../assets/img/jpg-ext.png')
      } else if (previewType === 'mp4') {
        return require('../../assets/img/vidoe-ext.png')
      } else {
        return require('../../assets/img/unknown-ext.png')
      }
    },
    // 获取文件列表
    getCaseDetails() {
      this.$Http.getCaseDetails({
        duoyuanCaseId: this.caseId
      }).then(res => {
        if (res.success) {
          this.details = res.data.filter(item => item.fileType !== 22)
        }
      })
    },
    // 关闭弹窗
    handleCloseDialog() {
      this.imgStr = ''
      this.pdfStr = ''
      this.videoStr = ''
      this.iframeLoading = false
    },
    setBaseUrl() {
      return process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_BASE_API
    },
    // 第二层预览222
    handleRiviewFile(sItem, dialogTitle, isWork, isTiaoJie) {
      if (isWork) {
        this.$Http.getCaseDetails({
          duoyuanCaseId: this.caseId
        }).then(res => {
          if (res.success) {
            res.data.forEach(item => [6, 7, 8, 9, 15, 16, 17, 18].includes(item.fileType) &&
              item.filePaths.forEach(fps => (fps.fileId === sItem.fileId) && this.pcView(fps.filePath)))
          }
        })
      } else {
        this.pcView(sItem.filePath)
      }
      this.signFileId = sItem.fileId
      // 是否显示调解员签字
      this.isWork = isTiaoJie
      this.dialogTitle = dialogTitle
    },
    pcView(str) {
      const previewType = str ? str.substring(str.lastIndexOf('.') + 1) : ''
      if (previewType === 'png' || previewType === 'jpeg' || previewType === 'jpg') {
        this.visiblePdf = false
        this.visibleWord = false
        this.visibleVideo = false
        this.visibleImg = true
        this.imgStr = str
      } else if (previewType === 'pdf') {
        this.visibleWord = false
        this.visibleVideo = false
        this.visibleImg = false
        this.visiblePdf = true
        this.pdfStr = str
      } else if (previewType === 'docx') {
        this.visibleVideo = false
        this.visibleImg = false
        this.visiblePdf = false
        this.visibleWord = true
        const xhr = new XMLHttpRequest()
        xhr.open('get', str, true)
        xhr.responseType = 'arraybuffer'
        xhr.onload = () => {
          if (xhr.status === 200) {
            const options = {
              className: 'docx', // 默认和文档样式类的类名/前缀
              inWrapper: true, //  启用围绕文档内容渲染包装器
              ignoreWidth: false, //  禁止页面渲染宽度
              ignoreHeight: false, //  禁止页面渲染高度
              ignoreFonts: false, //  禁止字体渲染
              breakPages: true, //  在分页符上启用分页
              ignoreLastRenderedPageBreak: true, //  禁用lastRenderedPageBreak元素的分页
              experimental: false, //  启用实验性功能（制表符停止计算）
              trimXmlDeclaration: true, //   如果为真，xml声明将在解析之前从xml文档中删除
              debug: false, //  启用额外的日志记录
              useBase64URL: true, // 如果为true，图片、字体等将被转换为base 64 URL，否则使用URL.createObjectURL
              useMathMLPolyfill: false, //  包括用于 chrome、edge 等的 MathML polyfill。
              showChanges: false // 启用文档更改（插入/删除）的实验性呈现
            }
            if (xhr.response.byteLength) {
              renderAsync(xhr.response, this.$refs.refWord, null, options)
            } else {
              this.$message.error('文件错误')
              this.visibleWord = false
            }
          }
        }
        xhr.send()
      } else if (previewType === 'mp4') {
        this.visibleImg = false
        this.visiblePdf = false
        this.visibleWord = false
        this.visibleVideo = true
        this.videoStr = str
      } else {
        this.visibleImg = false
        this.visiblePdf = false
        this.visibleWord = false
        this.visibleVideo = false
        this.$message.error('文件类型错误,只能是pdf/docx/png/jpg类型的文件')
      }
    },
    // 上传文件
    onUploadFileSuccess(response, file, fileList) {
      if (response.success) {
        this.$message.success('上传成功')
        this.getCaseDetails()
        this.visibleFile = false
      }
      this.uploadLoading = false
    },
    // 点击全屏展示
    clickFun() {
      if (!screenfull.isEnabled) {
        this.$message({ message: '你的浏览器不支持全屏', type: 'warning' })
        return false
      }
      screenfull.toggle()
    },
    // 全屏切换
    change() {
      this.isFullscreen = screenfull.isFullscreen
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
    },
    getToken() {
      return getToken({
        uid: parseInt(this.pId),
        appkey: config.appkey,
        appSecret: config.appSecret,
        channelName: this.$route.query.channelName
      }).then(token => {
        return token
      }, (e) => {
        throw e
      })
    },
    returnJoin(time = 2000) {
      setTimeout(() => {
        this.$router.push({
          path: '/',
          query: {
            path: 'multiple'
          }
        })
      }, time)
    },
    joinChannel(token) {
      if (!this.client) {
        message('内部错误，请重新加入房间')
        return
      }
      this.client
        .join({
          channelName: this.$route.query.channelName,
          uid: parseInt(this.pId),
          token,
          joinChannelRecordConfig: {
            recordAudio: true,
            recordVideo: true,
            recordType: 0
          }
        })
        .then(() => {
          console.info('加入房间成功，开始初始化本地音视频流')
          this.initLocalStream()
        })
        .catch((error) => {
          console.error('加入房间失败：', error)
          message(`${error}: 请检查appkey或者token是否正确`)
          this.returnJoin()
        })
    },
    initLocalStream() {
      // 初始化本地的Stream实例，用于管理本端的音视频流
      this.localStream = NERTC.createStream({
        uid: parseInt(this.pId),
        audio: true, // 是否启动mic
        video: true, // 是否启动camera
        screen: false // 是否启动屏幕共享
      })

      // 设置本地视频质量
      this.localStream.setVideoProfile({
        resolution: NERTC.VIDEO_QUALITY_720p, // 设置视频分辨率
        frameRate: NERTC.CHAT_VIDEO_FRAME_RATE_15 // 设置视频帧率
      })
      // 设置本地音频质量
      this.localStream.setAudioProfile('speech_standard')
      // 启动媒体，打开实例对象中设置的媒体设备
      this.localStream
        .init()
        .then(() => {
          console.warn('音视频开启完成，可以播放了')
          const div = self.$refs.large
          this.localStream.play(div)
          this.localStream.setLocalRenderMode({
            // 设置视频窗口大小
            width: div.clientWidth,
            height: div.clientHeight,
            cut: true // 是否裁剪
          })
          // 发布
          this.publish()
        })
        .catch((err) => {
          console.warn('音视频初始化失败: ', err)
          message('音视频初始化失败')
          this.localStream = null
        })
    },
    publish() {
      console.warn('开始发布视频流')
      // 发布本地媒体给房间对端
      this.client
        .publish(this.localStream)
        .then(() => {
          console.warn('本地 publish 成功')
        })
        .catch((err) => {
          console.error('本地 publish 失败: ', err)
          message('本地 publish 失败')
        })
    },
    subscribe(remoteStream) {
      // 这里可以控制是否订阅某一类媒体，这里设置的是用户主观意愿
      // 比如这里都是设置为true，如果stream-added事件中通知了是audio发布了，则本次调用会订阅音频，如果video、screen之前已经有stream-added通知，则也会同时订阅video、screen，反之会忽略
      remoteStream.setSubscribeConfig({
        audio: true,
        video: true,
        screen: true
      })
      this.client
        .subscribe(remoteStream)
        .then(() => {
          console.warn('本地 subscribe 成功')
        })
        .catch((err) => {
          console.warn('本地 subscribe 失败: ', err)
          message('订阅对方的流失败')
        })
    },
    setOrRelieveSilence() {
      const { isSilence } = this
      this.isSilence = !isSilence
      if (this.isSilence) {
        console.warn('关闭mic')
        this.localStream
          .close({
            type: 'audio'
          })
          .then(() => {
            console.warn('关闭 mic sucess')
          })
          .catch((err) => {
            console.warn('关闭 mic 失败: ', err)
            message('关闭 mic 失败')
          })
      } else {
        console.warn('打开mic')
        if (!this.localStream) {
          message('当前不能打开mic')
          return
        }
        this.localStream
          .open({
            type: 'audio'
          })
          .then(() => {
            console.warn('打开mic sucess')
          })
          .catch((err) => {
            console.warn('打开mic失败: ', err)
            message('打开mic失败')
          })
      }
    },
    stopOrOpenVideo() {
      const { isStop } = this
      this.isStop = !isStop
      if (this.isStop) {
        this.localStream
          .close({
            type: 'video'
          })
          .then(() => {
            console.warn('关闭摄像头 sucess')
          })
          .catch((err) => {
            console.warn('关闭摄像头失败: ', err)
            message('关闭摄像头失败')
          })
      } else {
        console.warn('打开摄像头')
        if (!this.localStream) {
          message('当前不能打开camera')
          return
        }
        this.localStream
          .open({
            type: 'video'
          })
          .then(() => {
            console.warn('打开摄像头 sucess')
            const div = self.$refs.large
            this.localStream.play(div)
            this.localStream.setLocalRenderMode({
              // 设置视频窗口大小
              width: div.clientWidth,
              height: div.clientHeight,
              cut: true // 是否裁剪
            })
          })
          .catch((err) => {
            console.warn('打开摄像头失败: ', err)
            message('打开摄像头失败')
          })
      }
    },
    //  初始化房间
    createInit() {
      this.client = NERTC.createClient({
        appkey: config.appkey,
        debug: false
      })
      // 监听事件
      this.client.on('peer-online', (event) => {
        // 获取pid和昵称
        this.$Http.getNickName({ pId: event.uid, caseId: this.caseId }).then(res => {
          if (res.success) {
            if (
              this.remoteUsers.every((item) => item.uid !== event.uid) &&
              this.remoteUsers.length < this.max - 1
            ) {
              this.remoteUsers = this.remoteUsers.concat({
                nickName: res.data.nickName,
                uid: res.data.pid
              })
              this.remoteUsers = this.remoteUsers.map((item) =>
                item.uid === res.data.pid
                  ? { ...item, nickName: res.data.nickName }
                  : { ...item }
              )
            }
          }
        })
      })

      this.client.on('peer-leave', (evt) => {
        console.warn(`${evt.uid} 离开房间`)
        this.remoteUsers = this.remoteUsers.filter(
          (item) => item.uid && item.uid !== evt.uid
        )
        this.remoteStreams = this.remoteStreams.filter(
          (item) => !!item.getId() && item.getId() !== evt.uid
        )
      })
      this.client.on('active-speaker', _data => {
        console.log('===== 当前在讲话的人：', _data)
      })
      this.client.on('volume-indicator', _data => {
        console.log('===== 正在说话的远端用户及其音量：', _data)
        this.remoteStreams.length && this.remoteStreams.map((item) => {
          this.$nextTick(() => {
            _data.length && (
              _data.find(items => {
                return parseInt(item.streamID) === parseInt(items.uid) && (item.audioLevelHelper = items.level)
              })
            )
          })
        })
      })
      this.client.on('stream-added', async (evt) => {
        // 收到房间中其他成员发布自己的媒体的通知，对端同一个人同时开启了麦克风、摄像头、屏幕贡献，这里会通知多次
        const stream = evt.stream
        const userId = stream.getId()
        console.warn(`收到 ${userId} 的发布 ${evt.mediaType} 的通知`) // mediaType为：'audio' | 'video' | 'screen'
        if (this.remoteStreams.some((item) => item.getId() === userId)) {
          console.warn('收到已订阅的远端发布，需要更新', stream)
          this.remoteStreams = this.remoteStreams.map((item) => {
            return item.getId() === userId ? stream : item
          })
          // 订阅其发布的媒体，可以渲染播放
          await this.subscribe(stream)
        } else if (this.remoteStreams.length < this.max - 1) {
          console.warn('收到新的远端发布消息', stream)
          this.remoteStreams = this.remoteStreams.concat(stream)
          // 订阅其发布的媒体，可以渲染播放
          await this.subscribe(stream)
        } else {
          console.warn('房间人数已满')
        }
        console.log(this.remoteStreams)
      })

      this.client.on('stream-removed', (evt) => {
        const stream = evt.stream
        if (!stream.audio) {
          stream.audioLevelHelper = null
        }
        const userId = stream.getId()
        console.warn(`收到 ${userId} 的停止发布 ${evt.mediaType} 的通知`) // mediaType为：'audio' | 'video' | 'screen'
        stream.stop(evt.mediaType)
        this.remoteStreams = this.remoteStreams.map((item) =>
          item.getId() === userId ? stream : item
        )
        console.warn('远端流停止订阅，需要更新', userId, stream)
      })

      this.client.on('stream-subscribed', (evt) => {
        const userId = evt.stream.getId()
        console.warn(`收到订阅 ${userId} 的 ${evt.mediaType} 成功的通知`) // mediaType为：'audio' | 'video' | 'screen'
        // 这里可以根据mediaType的类型决定播放策略
        const remoteStream = evt.stream
        // 用于播放对方视频画面的div节点
        const div = [...this.$refs.small].find((item) => {
          return Number(item.dataset.uid) === Number(remoteStream.getId())
        })
        // 这里可以控制是否播放某一类媒体，这里设置的是用户主观意愿
        // 比如这里都是设置为true，本次通知的mediaType为audio，则本次调用的play会播放音频，如果video、screen内部已经订阅成功，则也会同时播放video、screen，反之不播放
        const playOptions = {
          audio: true,
          video: true,
          screen: false
        }
        remoteStream.play(div, playOptions).then(() => {
          console.log('播放对端的流成功: ', playOptions)
          remoteStream.setRemoteRenderMode({
            // 设置视频窗口大小
            width: h > w ? 164 : 220,
            height: h > w ? 164 : 220,
            cut: true // 是否裁剪
          })
        }).catch((err) => {
          console.warn('播放对方视频失败了: ', err)
        })
        // 这里监听一下音频自动播放会被浏览器限制的问题（https://doc.yunxin.163.com/nertc/docs/jM3NDE0NTI?platform=web）
        remoteStream.on('notAllowedError', (err) => {
          const errorCode = err.getCode()
          console.log(err)
          console.log(err.getCode())
          if (errorCode === 41030) {
            Dialog.alert({
              title: '',
              message: '系统申请扬声器权限'
            }).then(() => {
              remoteStream.resume()
            })
          }
        })
      })

      this.client.on('uid-duplicate', () => {
        console.warn('==== uid重复，你被踢出')
      })

      this.client.on('error', (type) => {
        console.error('===== 发生错误事件：', type)
        if (type === 'SOCKET_ERROR') {
          console.warn('==== 网络异常，已经退出房间')
        }
      })

      this.client.on('accessDenied', (type) => {
        console.warn(`==== ${type}设备开启的权限被禁止`)
      })

      this.client.on('connection-state-change', (evt) => {
        console.warn(
          `网络状态变更: ${evt.prevState} => ${evt.curState}, 当前是否在重连：${evt.reconnect}`
        )
      })
    }
  }
}
</script>

<style scoped lang="less">
  [v-cloak] {
    display: none;
  }

  .main {
    display: flex;
    width: 100%;
    min-width: 1400px;
    overflow-x: auto;
    overflow-y: hidden;
    transition: all .3s ease-in-out;

    .wrapper {
      background-image: linear-gradient(179deg, #141417 0%, #181824 100%);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      width: 63%;

      .content {
        flex: 1;
        display: flex;
        position: relative;

        .main-window {
          height: 100%;
          width: calc(100% - 220px);
          background: #25252d;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .bot-line {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2000;
            width: 100%;
            background: rgba(0, 0, 0, .6);
            color: #FFF;
            padding: 5px 10px;
            font-size: 13px;
            line-height: 20px;
            text-align: left;
          }

          ::v-deep .nertc-video-container-local {
            transform: rotateY(0.5turn);

            video {
              object-fit: fill;
            }
          }
        }

        .sub-window-wrapper {
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          width: 220px;
          overflow-x: hidden;
          overflow-y: auto;
        }

        .sub-window {
          background: #25252d;
          border: 1px solid #4c4c4c;
          height: 220px;
          width: 100%;
          box-sizing: border-box;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          position: relative;

          .bot-line {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2000;
            width: 100%;
            background: rgba(0, 0, 0, .6);
            color: #FFF;
            padding: 5px;
            font-size: 12px;
            line-height: 12px;
            height: 24px;
            text-align: left;
            display: flex;
            align-items: center;

            i {
              display: inline-block;
              width: 14px;
              height: 14px;
              background-size: 100%;
              background-repeat: no-repeat;
              background-position: 50%;
              margin-right: 5px;
            }

            .media-audio {
              background-image: url('../../assets/img/icon/radiu-mute.png');
            }

            .media-video {
              background-image: url('../../assets/img/icon/video-mute.png');
            }

            .speak-video {
              background-image: url('../../assets/img/icon/speak-mute.png');
            }
          }

          ::v-deep .nertc-video-container-remote {
            height: 218px !important;
            transform: rotateY(0.5turn);

            video {
              object-fit: fill;
            }
          }

          .loading-text {
            display: block;
            width: 100%;
            text-align: center;
            line-height: 220px;
            font-size: 12px;
            color: #fff;
            font-weight: 400;
          }
        }
      }

      .tab-bar {
        height: 50px;
        background-image: linear-gradient(180deg, #292933 7%, #212129 100%);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.3);
        list-style: none;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;

        li {
          height: 50px;
          width: 110px;
          cursor: pointer;
          //静音
          &.silence {
            background: url("../../assets/img/icon/silence.png") no-repeat center;
            background-size: 60px 50px;

            &:hover {
              background: url("../../assets/img/icon/silence-hover.png") no-repeat center;
              background-size: 60px 50px;
            }

            &:active {
              background: url("../../assets/img/icon/silence-click.png") no-repeat center;
              background-size: 60px 50px;
            }

            &.isSilence {
              //已经开启静音
              background: url("../../assets/img/icon/relieve-silence.png") no-repeat center;
              background-size: 60px 50px;

              &:hover {
                background: url("../../assets/img/icon/relieve-silence-hover.png") no-repeat center;
                background-size: 60px 50px;
              }

              &:active {
                background: url("../../assets/img/icon/relieve-silence-click.png") no-repeat center;
                background-size: 60px 50px;
              }
            }
          }

          //结束按钮
          &.over {
            height: 33px;
            padding: 5px;
            border-radius: 25px;
            background: #FE3B30;
            color: #FFF;
            font-size: 13px;
            text-align: center;
            line-height: 23px;
            margin-left: 20px;

            span {
              display: block;
              font-size: 12px;
              line-height: 12px;
            }
          }

          &.paper {
            display: none;
            text-align: center;
            padding-top: 10px;

            img {
              width: 20px;
              height: 18px;
            }

            p {
              font-size: 12px;
              color: #D4D4D6;
              line-height: 12px;
              transform: scale(0.8);
            }
          }

          // 停止按钮
          &.stop {
            background: url("../../assets/img/icon/stop.png") no-repeat center;
            background-size: 60px 50px;

            &:hover {
              background: url("../../assets/img/icon/stop-hover.png") no-repeat center;
              background-size: 60px 50px;
            }

            &:active {
              background: url("../../assets/img/icon/stop-click.png") no-repeat center;
              background-size: 60px 50px;
            }

            //已经是停止状态
            &.isStop {
              background: url("../../assets/img/icon/open.png") no-repeat center;
              background-size: 60px 50px;

              &:hover {
                background: url("../../assets/img/icon/open-hover.png") no-repeat center;
                background-size: 60px 50px;
              }

              &:active {
                background: url("../../assets/img/icon/open-click.png") no-repeat center;
                background-size: 60px 50px;
              }
            }
          }
        }
      }

      .mobile-btn {
        display: none;
      }
    }

    .file {
      width: 37%;
      background: #393946;
      padding: 10px;

      .file-box {
        background: #ffffff;
        height: 100%;
        width: 100%;
        overflow-x: auto;
        border-radius: 3px;
        position: relative;

        .file-title {
          min-width: 547px;
          height: 60px;
          padding: 5px 10px;
          background: rgba(0, 0, 0, .09);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .mediate-status {
            font-size: 12px;
            background: rgba(0, 0, 0, .07);
            color: #333333;
            padding: 5px 10px;
            border-radius: 3px;
          }

          h4 {
            font-size: 15px;
            color: #4a4a4a;
            width: 220px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .file-show {
          min-width: 547px;
          height: calc(100% - 60px);
          overflow-x: hidden;
          overflow-y: scroll;
          padding: 10px 10px 49px;

          .bot-btn {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            min-width: 547px;
            padding: 10px;
            height: 50px;
            background: #fff;
            text-align: center;
            display: flex;
            align-items: center;
            box-shadow: 0 0 22px #d6d6d6;

            .upload-demo {
              ::v-deep .el-upload {
                width: 100%;
              }
            }

            button {
              width: 100%;
            }
          }

          ::v-deep .el-collapse-item__header {
            font-size: 14px;
          }

          ::v-deep .el-collapse-item__content {
            display: flex;
            flex-wrap: wrap;
          }

          .file-item {
            display: inline-block;
            padding: 10px;
            text-align: center;
            cursor: pointer;
            border-radius: 4px;
            transition: all .3s ease-in-out;
            position: relative;

            &:hover .del-modal {
              height: 100%;
              font-size: 13px;

              .del-sty {
                user-select: none;

                &:hover {
                  color: red;
                }
              }

              .view-sty {
                user-select: none;

                &:hover {
                  color: #337eff;
                }
              }
            }

            .del-modal {
              position: absolute;
              width: 100%;
              height: 0;
              border-radius: 4px;
              top: 0;
              left: 0;
              z-index: 3;
              background: rgba(0, 0, 0, .7);
              display: flex;
              justify-content: center;
              align-items: center;
              color: #ffffff;
              font-size: 0;
              transition: all ease-in-out .3s;
            }

            &:hover {
              box-shadow: 0 0 10px #acacac;
            }

            img {
              width: 32px;
              height: 32px;
            }

            p {
              width: 88px;
              font-size: 12px;
              line-height: 15px;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }
    }

    .dialog-box {
      height: 550px;
      width: 100%;
      border: 1px #e6e6e6 solid;
      border-radius: 4px;
    }

    .dialog-img {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        object-fit: cover;
      }
    }

    .dialog-pdf {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      overflow: hidden;
    }
  }

  ::v-deep .el-dialog__body {
    padding: 0 10px 10px;
    overflow: hidden;
    border-radius: 4px;
  }

  ::v-deep .w-e-toolbar {
    z-index: 2000 !important;
  }

  ::v-deep .w-e-text-container {
    height: 550px !important;
    border: 0 !important;
    z-index: 1999 !important;

    .w-e-text {
      height: 550px !important;
    }
  }

  .drawer-main {
    height: 100%;
    overflow: hidden;

    .sub-file-show {
      height: calc(100% - 60px);
      font-size: 13px;
      color: #979797;
      box-shadow: 0 0 10px #cad0d9;
      overflow-y: auto;
      padding: 5px;

      .file-item {
        display: inline-block;
        text-align: center;
        margin: 10px 5px 5px 5px;

        img {
          width: 32px;
        }

        p {
          width: 105px;
          font-size: 12px;
          line-height: 15px;
          word-wrap: break-word;
          word-break: break-all;
        }
      }

      .mobile-img {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          max-width: 100%;
          object-fit: cover;
        }
      }
    }

    .file-btn {
      margin-top: 10px;
      height: 50px;
      text-align: center;
      display: flex;
      justify-content: space-around;

      .upload-demo {
        ::v-deep .el-upload {
          width: 100%;
        }
      }
    }
  }

  @media screen and (min-width: 751px) {
    ::v-deep .docx-wrapper {
      overflow: auto;
      height: 550px;
      border: 1px #e6e6e6 solid;
      border-radius: 4px;

      .docx {
        width: 100% !important;
        height: 100% !important;
        padding: 20px !important;
        overflow: auto;
      }
    }
  }

  @media screen and (max-width: 750px) {
    ::v-deep .docx-wrapper {
      overflow: auto;
      height: auto;
      border: 1px #e6e6e6 solid;
      border-radius: 4px;
      padding: 0;

      .docx {
        width: 100% !important;
        height: 100% !important;
        padding: 10px !important;
        overflow: auto;
        margin: 0;
      }
    }

    .main {
      min-width: 100%;

      .wrapper {
        width: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
        position: relative;

        .content {
          .main-window {
            width: 100%;
            height: calc(100% - 160px);
          }

          .sub-window-wrapper {
            position: absolute;
            top: calc(100% - 160px);
            left: 0;
            height: 160px;
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
          }

          .sub-window {
            width: 166px;
            height: 100%;
            display: inline-block;
            overflow: hidden;

            ::v-deep .nertc-video-container-remote {
              height: 164px !important;

              video {
                object-fit: fill;
              }
            }

            .loading-text {
              line-height: 160px;
            }
          }
        }

        .tab-bar {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          /*li {*/
          /*  width: 88px;*/
          /*}*/

          li.over {
            margin-left: 5px;
            padding: 5px 0;
          }

          .paper {
            display: inline-block !important;
          }
        }

        .mobile-btn {
          display: block;
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          height: 50px;
          cursor: pointer;

          .div-btn {
            display: inline-block;
            width: 50%;
            text-align: center;
            color: #FFF;
            padding: 5px;

            img {
              width: 25px;
              height: 23px;
            }

            p {
              font-size: 12px;
              color: #D4D4D6;
              line-height: 12px;
            }
          }

          .div-p {
            width: 50%;

            p {
              line-height: 20px;
            }
          }
        }
      }

      .file {
        display: none;
      }
    }
  }
</style>
